export default __webpack_public_path__ + "static/lookbook-2-6fc92619ae4157b3e169f0a5721aa827.webp";